import { DisplayOn } from "../display-on/DisplayOn";
import { Props } from "./Responsive.Parts";

export const Responsive = ({ mobile, desktop }: Props) => (
  <>
    <DisplayOn mobile>{mobile}</DisplayOn>
    <DisplayOn desktop>{desktop}</DisplayOn>
  </>
);
